const ProjectClaimsService = class ProjectClaimsService {
  constructor ($http, Configuration, ModalService, ProjectService, UserService, moment) {
    'ngInject'

    this.$http = $http
    this.moment = moment
    this.Configuration = Configuration
    this.ModalService = ModalService
    this.UserService = UserService
    this.ProjectService = ProjectService
  }

  init () {
    console.log('ProjectClaimsService > init')
  }

  get userClaimCounts () {
    return {
      available: this.UserService.user?.availableClaimCount,
      current: this.UserService.user?.currentClaimCount,
      max: this.UserService.user?.maxClaimCount
    }
  }

  get projectClaimCounts () {
    return {
      available: this.ProjectService.project?.availableClaimCount,
      current: this.ProjectService.project?.currentClaimCount,
      max: this.ProjectService.project?.maxClaimCount
    }
  }

  get claimExpertsNames () {
    if (this.ProjectService.project?.engagementClaims) {
      return this.ProjectService.project?.engagementClaims.map(claim => claim.expert.fullName).join(', ')
    }
    return 'N/A'
  }

  get showClaimExpertsNames () {
    return this.ProjectService.project?.engagementClaims?.length > 0
  }

  // The current expert's own claim on this project (if any).
  get currentExpertClaim () {
    const userId = this.UserService.user?.id
    return this.ProjectService.project?.engagementClaims?.find(claim => claim.expert?.id === userId)
  }

  // Configured engagement window in minutes (BE exposes claimExpiryTimeout on
  // the user object). Used for the pre-claim warning copy.
  get claimExpiryMinutes () {
    return this.UserService.user?.claimExpiryTimeout ?? null
  }

  // UTC datetime the current expert's claim expires, or null when there is
  // no active timer (no claim, or a public comment was already posted).
  get claimExpiresAt () {
    return this.currentExpertClaim?.expiredAt ?? null
  }

  // First-comment wait (KB-8789). BE exposes reading_seconds and
  // earliest_short_comment_at on the expert's project payload (BE KB-8788);
  // both are absent for clients and for projects without claiming.
  get readingSeconds () {
    const seconds = this.ProjectService.project?.readingSeconds
    return typeof seconds === 'number' && seconds >= 0 ? seconds : null
  }

  // Whole minutes, rounded up, never below 1. Null when BE sent nothing.
  get readingMinutes () {
    const seconds = this.readingSeconds
    if (seconds === null) {
      return null
    }
    return Math.max(1, Math.ceil(seconds / 60))
  }

  get earliestShortCommentAt () {
    return this.ProjectService.project?.earliestShortCommentAt ?? null
  }

  // BE dates come either as ISO 8601 or "YYYY-MM-DD HH:mm:ss UTC" (claim.expiredAt).
  // Returns milliseconds until the date, or null when unparsable / missing.
  msUntil (dateString) {
    if (!dateString) {
      return null
    }
    const moment = this.moment
    const parsed = moment.utc(dateString, [moment.ISO_8601, 'YYYY-MM-DD HH:mm:ss [UTC]'], true)
    if (!parsed.isValid()) {
      return null
    }
    return parsed.diff(moment.utc())
  }

  claimProject (projectId) {
    return this.$http
      .post(`${this.Configuration.apiUrl}/experts/projects/engagement_claims`, { projectId })
      .then(response => response.data)
  }

  unclaimProject (projectId) {
    return this.$http
      .delete(`${this.Configuration.apiUrl}/experts/projects/engagement_claims`, {
        params: {
          project_id: projectId
        }
      })
      .then(response => response.data)
  }
}
export default ProjectClaimsService
